import {FC} from 'react'
import {RouteComponentProps} from 'react-router-dom'
import {ChildcareInfoForm} from 'features/procedures/Flow/ChildcareInfoForm'

// Todo 画面「手続き情報編集」 link 経由で ChildcareInfoForm を単独編集する画面
const ChildcareInfoEdit: FC<RouteComponentProps<{id: string}>> = ({match, history}) => {
  const {id} = match.params

  const afterSubmit = async () => {
    history.push(`/procedure_statuses/${id}`)
  }

  return (
    <ChildcareInfoForm
      procedureStatusId={id}
      submitText="保存"
      afterSubmit={afterSubmit}
      procedureContext="admin"
      isTodoEdit
    />
  )
}

export default ChildcareInfoEdit
